import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";
import "../Navigation.scss";
import FontAwesomeIcon from "../../Icon";

export const GenericLink = ({ link, collapseSideBar }) => (
  <li
    title={link.label}
    className="navigation__link"
    key={`nav-link-${link.label}`}
  >
    <NavLink
      to={link.path}
      className={classNames("navigation__anchor", {
        "navigation__anchor--collapsed": collapseSideBar,
      })}
      activeClassName="navigation__anchor--active"
    >
      <FontAwesomeIcon weight="light" glyph={link.icon} />
      <div
        className={classNames("navigation__anchor--label", {
          "navigation__anchor--label--collapse": collapseSideBar,
        })}
      >
        {link.label}
      </div>
    </NavLink>
  </li>
);
